import { lazy } from 'react';

export const Account = lazy(()=>import('../containers/Account'))
export const RackspaceSettings = lazy(()=>import('../containers/RackspaceSettings/rackspaceSettings'))
export const SubscriptionUpgrade = lazy(()=>import('../containers/SubscriptionUpgrade/subscriptionUpgrade'))
export const GeneralError = lazy(()=>import('../components/GeneralError/generalError'))
export const CocoDialog =lazy(()=>import('../components/Dialog/dialog'))